export default __webpack_public_path__ + "static/insta1-9926a87cc72e100cb872cd5d1bc735ca.jpg";